module.exports = __webpack_public_path__ + "4331f9197299c1180454b4ee4391d60a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/Yummy/images/backgrounds/10.png
// module id = 40
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18